import React from "react";
import "./footer.scss";
import logo from "../../assets/logo.png";
// import name from "../../assets/image 3.png";
// import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useNavigate } from "react-router-dom";
const Footer = () => {
  const navigate = useNavigate();
  return (
    <div className="footer_wrapper">
      <div className="footer_section">
        <div className="upper">
          <div className="left">
            <img src={logo} alt="logo" />
            <div className="name"></div>
          </div>
          {/* <div className="middle">
            <h3>Sign Up for the Newsletter </h3>
            <form>
              <input type="email" placeholder="Submit your e-mail" />
            </form>
          </div> */}
          <div className="right">
            <ul>
              <li onClick={() => navigate("/support")}>Support</li>
              <li onClick={() => navigate("/faq")}>FAQs</li>
              <li
                onClick={() => {
                  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                  navigate("/aboutus");
                }}
              >
                About Us
              </li>
              {/* <li
                onClick={() => {
                  // window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                  navigate("/privacypolicy");
                }}
              >
                Privacy Policy
              </li>
              <li
                onClick={() => {
                  // window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                  navigate("/termsandcondition");
                }}
              >
                Terms & Conditions
              </li> */}
              <a
                href="https://www.linkedin.com/company/ballers-life/"
                target="_blank"
                rel="noreferrer"
              >
                <LinkedInIcon />
              </a>
              <a
                href="https://www.instagram.com/ballerslife.official?igsh=MzNlNGNkZWQ4Mg=="
                target="_blank"
                rel="noreferrer"
              >
                <InstagramIcon />
              </a>
            </ul>
          </div>
        </div>
        <div className="bottom">
          <div className="rectangle"></div>
          <p>
            14/4, J Block , 3rd Avenue, Anna Nagar East, Chennai, Tamil Nadu,
            600102&nbsp;•&nbsp;© 2024 Ballers&nbsp;•&nbsp;All Rights
            Reserved&nbsp;•&nbsp;
            <span
              onClick={() => {
                navigate("/termsandcondition");
              }}
            >
              Terms and Conditions
            </span>
            &nbsp;•&nbsp;
            <span
              onClick={() => {
                navigate("/privacypolicy");
              }}
            >
              Privacy Policy
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
